<script setup>
import { ref } from "vue";
import { useFieldsStore } from "@/stores/storeFieldData";
import { useValidation } from "@/utils/useValidataion";

const storeField = useFieldsStore();

const props = defineProps({
	selectOptions: {
		type: Array,
		required: true,
	},
});

const dropdownRef = ref(null);
const dropdownRefHeight = ref(null);
const isOpen = ref(false);
const selectedId = ref(null);
const selectedTitle = ref("");

const { validation, isValid, isTouched, textError } = useValidation(selectedId);

const showDropdownList = () => {
	isOpen.value = !isOpen.value;
	dropdownRefHeight.value = dropdownRef.value?.offsetHeight || 80;
};

const changeValueSelect = (optionId, optionTitle) => {
	selectedId.value = optionId;
	selectedTitle.value = optionTitle;
	isOpen.value = false;
	isTouched.value = true;
	validation("id");
	storeField.updateFields("select", "id", selectedId.value);
};
</script>
<template>
	<div class="dropdown input">
		<label :class="['dropdown-label', { '--visible': isOpen }]">
			<input
				ref="dropdownRef"
				v-model="selectedTitle"
				@click="showDropdownList"
				:class="['dropdown__button input__field', isTouched && (isValid ? 'valid' : 'not-valid')]"
				:placeholder="selectedTitle"
				@blur="validation('id')"
				@focus="validation('id')"
				readonly
			/>
			<span class="input__title">Тема обращения</span>
		</label>
		<Transition>
			<div :class="['dropdown__list']" v-if="isOpen" :style="{ top: dropdownRefHeight + 5 + 'px' }">
				<ul class="dropdown__list-scroll list-scrollbar">
					<li v-for="{ title, id } in props.selectOptions" :key="id" @click="changeValueSelect(id, title)" class="dropdown__list-item" :data-value="id">
						{{ title }}
					</li>
				</ul>
			</div>
		</Transition>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.v-enter-active,
.v-leave-active {
	transition: all 0.25s ease-out;
}

.v-enter-from {
	opacity: 0;
	transform: translate(0%, 20px);
}
.v-leave-to {
	opacity: 0;
	transform: translate(0%, 20px);
}

.section-dropdown {
	max-width: 300px;
}
.dropdown {
	position: relative;
}

.dropdown__button {
	position: relative;
	display: block;
	width: 100%;
	text-align: left;
	padding: 29px 50px 12px 0px;
	font-weight: 400;
	font-size: 20px;
	line-height: 140%;
	cursor: pointer;

	overflow: hidden;
	text-overflow: ellipsis;
	&.--visible {
		&::after {
			transform: translateY(-50%) rotateX(180deg);
		}
	}
	&.valid {
		color: var(--text-default-100);
	}
	&::placeholder {
		color: var(--text-default-100);
	}
	@media (max-width: vars.$x480) {
		padding: 19px 40px 9px 0px;
		font-size: 16px;
	}
}

.dropdown__button:focus,
.dropdown__button--active {
	// outline: none;
	// box-shadow: 0px 0px 0px 4px rgba(176, 198, 225, 0.6);
}
.dropdown-label {
	&::after {
		content: "";
		position: absolute;
		top: 50%;
		right: 28px;
		transform: translateY(-50%) rotateX(0deg);
		background-image: url("@/assets/img/icons/select_icon.svg");
		background-repeat: no-repeat;
		background-position: 0px 0px; /* x y*/
		background-size: auto; /* w h*/
		width: 24px;
		height: 24px;
		pointer-events: none;
		transition: var(--transition) ease-in;
		@media (max-width: vars.$x480) {
			right: 10px;
		}
	}

	&.--visible {
		&::after {
			transform: translateY(-50%) rotateX(180deg);
		}
	}
}
.dropdown__button::after {
}

.dropdown__list {
	position: absolute;
	left: 0;
	top: 80px;

	margin: 0;
	list-style-type: none;
	box-shadow: 0 9px 24px 0 rgba(0, 0, 0, 0.06);
	background: var(--fill-inverse-1);
	border-radius: 2.4rem;
	overflow: hidden;
	width: 100%;
	z-index: 2;
	@media (max-width: vars.$x480) {
		border-radius: 14px 4px;
		top: 55px;
		box-shadow: -2px 2px 0 0 var(--main-dark-100);
	}
}

.dropdown__list-item {
	font-weight: 500;
	font-size: 2rem;
	line-height: 140%;
	color: var(--text-default-100);
	margin: 0;
	padding: 0;
	border-bottom: 0px;
	padding: 10px 30px;
	cursor: pointer;
	@media (max-width: vars.$x480) {
		padding: 5px 15px;
		font-size: 16px;
	}
}

.dropdown__list-item:first-child {
	padding-top: 20px;
}

.dropdown__list-item:last-child {
	padding-bottom: 20px;
}

.dropdown__list-item:hover {
	background: rgba(176, 198, 225, 0.26);
}

.dropdown__input-hidden {
	display: none;
}
.dropdown__list-scroll {
	height: auto;
	// height: 146px;
	// padding: 10px 0px 10px 0px;
}
.dropdown__list-scroll--height {
	height: 125px;
}
</style>
